/**
 * @generated SignedSource<<7cf0f1c5c532c63da1a580ce81e16b9c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentTitleWithByLine_content$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ByLine_content" | "ContentTitle_content">;
  readonly " $fragmentType": "ContentTitleWithByLine_content";
};
export type ContentTitleWithByLine_content$key = {
  readonly " $data"?: ContentTitleWithByLine_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "useNewContentTopper",
    "variableName": "useNewContentTopper"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useNewContentTopper"
    }
  ],
  "kind": "Fragment",
  "name": "ContentTitleWithByLine_content",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ContentTitle_content"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "ByLine_content"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "d024d1eaec00917f3ef60d940b2f780d";

export default node;
